import React from 'react';

const IconAppStore = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    viewBox="0 0 512 512"
    fill="currentColor"
    stroke="none"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round">
    <path
      fill="currentColor"
      d="M407,0H105C47.103,0,0,47.103,0,105v302c0,57.897,47.103,105,105,105h302c57.897,0,105-47.103,105-105V105
			C512,47.103,464.897,0,407,0z M157.649,394.515c-4.625,8.011-13.046,12.494-21.693,12.495c-4.239,0-8.531-1.077-12.458-3.344
			c-11.938-6.892-16.043-22.212-9.151-34.15l4.917-8.516h57.735L157.649,394.515z M110.5,341c-13.785,0-25-11.215-25-25
			c0-13.785,11.215-25,25-25h49.178l67.454-116.834l-18.281-31.664c-6.892-11.938-2.788-27.258,9.15-34.151h0.001
			c11.938-6.892,27.258-2.786,34.15,9.151l3.848,6.665l3.848-6.664c6.895-11.939,22.215-16.043,34.15-9.151
			c5.783,3.339,9.92,8.73,11.648,15.18c1.729,6.45,0.841,13.188-2.498,18.971L217.413,291h54.079l28.868,50H110.5z M401.5,341
			h-20.311l16.463,28.515c6.893,11.937,2.788,27.257-9.149,34.15c-3.853,2.224-8.129,3.361-12.461,3.361
			c-2.172,0-4.356-0.285-6.511-0.863c-6.451-1.729-11.842-5.866-15.181-11.65l-86.804-150.348l28.867-50L352.322,291H401.5
			c13.785,0,25,11.215,25,25C426.5,329.785,415.285,341,401.5,341z"
    />
  </svg>
);

export default IconAppStore;
